import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';
import { Loader } from '@keethealth/keet-ui';
import _ from 'lodash';
import Layout from 'common/Layout';

import { getCurrentSession } from 'services/auth';
import { readProfile } from 'services/api';
import { logoutUser } from 'redux/auth/actions';
import Client from './client';

class AuthRoute extends Component {
  static defaultProps = {
    isPublic: false,
  };

  static propTypes = {
    isPublic: PropTypes.bool,
    computedMatch: PropTypes.shape({
      path: PropTypes.string,
    }),
  };

  static defaultProps = {
    computedMatch: {},
  }

  state = {
    session: false,
    roles: [],
    waiting: true,
  }

  async componentDidMount() {
    await this.checkRole();
  }

  async componentWillReceiveProps(prevProps) {
    /**
     * Check the computed path variable.
     * Without this, each route change checks session and renders loader
     * Breaks flow on pages where states need to be passed between url parameters
     */
    if (prevProps.computedMatch.path !== this.props.computedMatch.path) {
      await this.checkRole();
    }
  }

  checkRole = async () => {
    this.setState({
      waiting: true,
    });
    let session;
    let roles = [];
    try {
      session = await getCurrentSession();
      if (session.accessToken) {
        const profile = await readProfile();
        if (profile) {
          roles = profile.data.attributes.roles;
        }
      }
    } catch (e) {
      console.log('error', e);
      session = false;
    }

    this.setState({
      session,
      roles,
      waiting: false,
    });
  }

  render() {
    const { isPublic } = this.props;
    const otherProps = this.props;
    const { session, roles, waiting } = this.state;
    if (waiting) {
      return <Loader />;
    }
    // If user is authenticated
    if (session.accessToken) {
      if (!_.includes(roles, 'patient')) {
        Client.getStore().dispatch(logoutUser());
        return <Redirect to={'/login'} />;
      }
      // If the route is public, redirect to private root.
      if (isPublic) {
        return <Redirect to={'/my_tasks'} />;
      }
      // If the route is private, proceed.
      return (
        <Layout>
          <Route {...otherProps} />
        </Layout>
      );
    }
    // If user route is public and user not authenticated, proceed.
    if (isPublic) {
      return <Route {...otherProps} />;
    }
    // If the route is private and user is not authenticated.
    return <Redirect to={'/login'} />;
  }
}

export default AuthRoute;
